import { useState, useEffect } from 'react';
import { useApi, githubAuthApiRef } from '@backstage/core-plugin-api';
import { fetchRepoVariable } from './githubApi';

interface UseGithubRepoVariableResult {
  options: string[];
  loading: boolean;
  error: string | null;
}

export function useGithubRepoVariable(
  owner: string,
  repo: string | undefined,
  variableName: string,
  separator = ',',
): UseGithubRepoVariableResult {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const githubAuth = useApi(githubAuthApiRef);

  useEffect(() => {
    if (!repo || !variableName) {
      setOptions([]);
      setError(null);
      return;
    }

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = await githubAuth.getAccessToken(['repo']);
        const result = await fetchRepoVariable(token, owner, repo, variableName, separator);
        if (result.length === 0) {
          setError(`Variable '${variableName}' not found in repository`);
        }
        setOptions(result);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch variable');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [githubAuth, owner, repo, variableName, separator]);

  return { options, loading, error };
}
